import React from 'react';

/**
 * Manual FMCSA verification is handled internally without user notification.
 * Banner intentionally renders nothing. Kept as a no-op to preserve imports.
 */
export const ManualPendingBanner: React.FC = () => null;

export default ManualPendingBanner;
